export const getEditUsersPermission = (roleId) => {
    return roleId === 1 ? true : false
}

export const naicMemberRoleCheck = (roleId) => {
    return roleId !== 3 ? true : false
}

export const getCreateAssessmentPermission = (roleId) => {
    return roleId === 1 ? true : false
}

export const getPostPaymentPermission = (roleId) => {
    return roleId === 1 ? true : false
}

